export default {"src":"/_next/static/media/chevron-in-circle.97864138.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};